import React, { useState, useMemo } from "react";
import "../UIcss/Icons.css";
import Pagination from "./Pagination.jsx";
import CodeViewer from "./CodeViewer.jsx";
import { FaFont } from "react-icons/fa";
import { LuCopy } from "react-icons/lu";

// Import all icons needed
import {
  FaGraduationCap,
  FaBook,
  FaChalkboardTeacher,
  FaUniversity,
  FaSchool,
  FaUserGraduate,
  FaLaptopCode,
  FaDatabase,
  FaServer,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaNodeJs,
  FaPython,
  FaJava,
  FaPhp,
  FaSwift,
  FaRust,
  FaMoneyBillWave,
  FaChartLine,
  FaPiggyBank,
  FaCreditCard,
  FaCoins,
  FaWallet,
  FaHandHoldingUsd,
  FaLandmark,
  FaFileInvoiceDollar,
  FaCalculator,
  FaHeart,
  FaStethoscope,
  FaUserMd,
  FaAmbulance,
  FaFirstAid,
  FaPills,
  FaSyringe,
  FaDna,
  FaMicroscope,
  FaHospital,
  FaAppleAlt,
  FaPlane,
  FaHotel,
  FaMapMarkedAlt,
  FaSuitcase,
  FaPassport,
  FaTicketAlt,
  FaUmbrellaBeach,
  FaMountain,
  FaCity,
  FaGlobeAmericas,
  FaMusic,
  FaGuitar,
  FaDrum,
  FaMicrophone,
  FaHeadphones,
  FaCompactDisc,
  FaSpotify,
  FaSoundcloud,
  FaPlay,
  FaPause,
  FaGamepad,
  FaGhost,
  FaPuzzlePiece,
  FaChess,
  FaDice,
  FaSteam,
  FaTwitch,
  FaXbox,
  FaPlaystation,
  FaRobot,
  FaUtensils,
  FaHamburger,
  FaPizzaSlice,
  FaCoffee,
  FaBeer,
  FaWineGlass,
  FaCocktail,
  FaCarrot,
  FaIceCream,
  FaCar,
  FaBus,
  FaTrain,
  FaSubway,
  FaBicycle,
  FaMotorcycle,
  FaShip,
  FaPlaneDeparture,
  FaTaxi,
  FaTruck,
  FaSun,
  FaMoon,
  FaCloud,
  FaCloudRain,
  FaSnowflake,
  FaWind,
  FaBolt,
  FaStar,
  FaMeteor,
  FaRainbow,
  FaTree,
  FaLeaf,
  FaSeedling,
  FaCannabis,
  FaPagelines,
  FaPaw,
  FaDog,
  FaCat,
  FaFish,
  FaHorse,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaPinterest,
  FaSnapchat,
  FaTiktok,
  FaWhatsapp,
  FaTelegram,
  FaApple,
  FaAndroid,
  FaWindows,
  FaLinux,
  FaChrome,
  FaFirefox,
  FaSafari,
  FaEdge,
  FaOpera,
  FaInternetExplorer,
  FaLock,
  FaKey,
  FaShieldAlt,
  FaUserSecret,
  FaFingerprint,
  FaUnlock,
  FaUserLock,
  FaFileContract,
  FaIdCard,
  FaUserShield,
  FaShoppingCart,
  FaStore,
  FaShoppingBag,
  FaTags,
  FaBarcode,
  FaGift,
  FaTruckLoading,
  FaBoxOpen,
  FaAmazon,
  FaEbay,
  FaHome,
  FaBuilding,
  FaWarehouse,
  FaIgloo,
  FaCampground,
  FaDoorOpen,
  FaBed,
  FaBath,
  FaChair,
  FaCouch,
  FaCamera,
  FaVideo,
  FaFilm,
  FaImage,
  FaPhotoVideo,
  FaTv,
  FaBroadcastTower,
  FaMicrophoneAlt,
  FaVolumeUp,
  FaSlidersH,
  FaPen,
  FaPencilAlt,
  FaEdit,
  FaEraser,
  FaPaintBrush,
  FaPalette,
  FaFillDrip,
  FaStamp,
  FaCut,
  FaCopy,
  FaPhone,
  FaMobileAlt,
  FaTabletAlt,
  FaLaptop,
  FaDesktop,
  FaKeyboard,
  FaMouse,
  FaPrint,
  FaFax,
  FaSatellite,
  FaTools,
  FaWrench,
  FaHammer,
  FaScrewdriver,
  FaRuler,
  FaMagnet,
  FaBatteryFull,
  FaLightbulb,
  FaPlug,
  FaPowerOff,
  FaUser,
  FaUsers,
  FaSearch,
  FaBars,
  FaTimes,
  FaCheck,
  FaArrowRight,
  FaArrowLeft,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

import {
  MdEmail,
  MdMessage,
  MdChat,
  MdForum,
  MdCall,
  MdContactMail,
  MdContactPhone,
  MdImportContacts,
  MdPermContactCalendar,
  MdNotifications,
  MdDashboard,
  MdSettings,
  MdAccountCircle,
  MdLogout,
  MdLogin,
  MdHelp,
  MdInfo,
  MdWarning,
  MdError,
  MdCheckCircle,
} from "react-icons/md";

const rawIcons = [
  { Icon: FaGraduationCap, name: "Graduation", componentName: "FaGraduationCap" },
  { Icon: FaBook, name: "Book", componentName: "FaBook" },
  { Icon: FaChalkboardTeacher, name: "Teacher", componentName: "FaChalkboardTeacher" },
  { Icon: FaUniversity, name: "University", componentName: "FaUniversity" },
  { Icon: FaSchool, name: "School", componentName: "FaSchool" },
  { Icon: FaUserGraduate, name: "Student", componentName: "FaUserGraduate" },
  { Icon: FaLaptopCode, name: "Coding", componentName: "FaLaptopCode" },
  { Icon: FaDatabase, name: "Database", componentName: "FaDatabase" },
  { Icon: FaServer, name: "Server", componentName: "FaServer" },
  { Icon: FaHtml5, name: "HTML5", componentName: "FaHtml5" },
  { Icon: FaCss3Alt, name: "CSS3", componentName: "FaCss3Alt" },
  { Icon: FaJs, name: "JavaScript", componentName: "FaJs" },
  { Icon: FaReact, name: "React", componentName: "FaReact" },
  { Icon: FaNodeJs, name: "Node.js", componentName: "FaNodeJs" },
  { Icon: FaPython, name: "Python", componentName: "FaPython" },
  { Icon: FaJava, name: "Java", componentName: "FaJava" },
  { Icon: FaPhp, name: "PHP", componentName: "FaPhp" },
  { Icon: FaSwift, name: "Swift", componentName: "FaSwift" },
  { Icon: FaRust, name: "Rust", componentName: "FaRust" },
  { Icon: FaMoneyBillWave, name: "Money", componentName: "FaMoneyBillWave" },
  { Icon: FaChartLine, name: "Chart", componentName: "FaChartLine" },
  { Icon: FaPiggyBank, name: "Savings", componentName: "FaPiggyBank" },
  { Icon: FaCreditCard, name: "Card", componentName: "FaCreditCard" },
  { Icon: FaCoins, name: "Coins", componentName: "FaCoins" },
  { Icon: FaWallet, name: "Wallet", componentName: "FaWallet" },
  { Icon: FaHandHoldingUsd, name: "Investment", componentName: "FaHandHoldingUsd" },
  { Icon: FaLandmark, name: "Bank", componentName: "FaLandmark" },
  { Icon: FaFileInvoiceDollar, name: "Invoice", componentName: "FaFileInvoiceDollar" },
  { Icon: FaCalculator, name: "Calc", componentName: "FaCalculator" },
  { Icon: FaHeart, name: "Heart", componentName: "FaHeart" },
  { Icon: FaStethoscope, name: "Stethoscope", componentName: "FaStethoscope" },
  { Icon: FaUserMd, name: "Doctor", componentName: "FaUserMd" },
  { Icon: FaAmbulance, name: "Ambulance", componentName: "FaAmbulance" },
  { Icon: FaFirstAid, name: "First Aid", componentName: "FaFirstAid" },
  { Icon: FaPills, name: "Meds", componentName: "FaPills" },
  { Icon: FaSyringe, name: "Vaccine", componentName: "FaSyringe" },
  { Icon: FaDna, name: "DNA", componentName: "FaDna" },
  { Icon: FaMicroscope, name: "Science", componentName: "FaMicroscope" },
  { Icon: FaHospital, name: "Hospital", componentName: "FaHospital" },
  { Icon: FaPlane, name: "Plane", componentName: "FaPlane" },
  { Icon: FaHotel, name: "Hotel", componentName: "FaHotel" },
  { Icon: FaMapMarkedAlt, name: "Map", componentName: "FaMapMarkedAlt" },
  { Icon: FaSuitcase, name: "Luggage", componentName: "FaSuitcase" },
  { Icon: FaPassport, name: "Passport", componentName: "FaPassport" },
  { Icon: FaTicketAlt, name: "Ticket", componentName: "FaTicketAlt" },
  { Icon: FaUmbrellaBeach, name: "Beach", componentName: "FaUmbrellaBeach" },
  { Icon: FaMountain, name: "Mountain", componentName: "FaMountain" },
  { Icon: FaCity, name: "City", componentName: "FaCity" },
  { Icon: FaGlobeAmericas, name: "World", componentName: "FaGlobeAmericas" },
  { Icon: FaMusic, name: "Music", componentName: "FaMusic" },
  { Icon: FaGuitar, name: "Guitar", componentName: "FaGuitar" },
  { Icon: FaDrum, name: "Drum", componentName: "FaDrum" },
  { Icon: FaMicrophone, name: "Mic", componentName: "FaMicrophone" },
  { Icon: FaHeadphones, name: "Headphones", componentName: "FaHeadphones" },
  { Icon: FaCompactDisc, name: "CD", componentName: "FaCompactDisc" },
  { Icon: FaSpotify, name: "Spotify", componentName: "FaSpotify" },
  { Icon: FaSoundcloud, name: "Soundcloud", componentName: "FaSoundcloud" },
  { Icon: FaPlay, name: "Play", componentName: "FaPlay" },
  { Icon: FaPause, name: "Pause", componentName: "FaPause" },
  { Icon: FaGamepad, name: "Gamepad", componentName: "FaGamepad" },
  { Icon: FaGhost, name: "Ghost", componentName: "FaGhost" },
  { Icon: FaPuzzlePiece, name: "Puzzle", componentName: "FaPuzzlePiece" },
  { Icon: FaChess, name: "Chess", componentName: "FaChess" },
  { Icon: FaDice, name: "Dice", componentName: "FaDice" },
  { Icon: FaSteam, name: "Steam", componentName: "FaSteam" },
  { Icon: FaTwitch, name: "Twitch", componentName: "FaTwitch" },
  { Icon: FaXbox, name: "Xbox", componentName: "FaXbox" },
  { Icon: FaPlaystation, name: "PS", componentName: "FaPlaystation" },
  { Icon: FaRobot, name: "Bot", componentName: "FaRobot" },
  { Icon: FaUtensils, name: "Utensils", componentName: "FaUtensils" },
  { Icon: FaHamburger, name: "Burger", componentName: "FaHamburger" },
  { Icon: FaPizzaSlice, name: "Pizza", componentName: "FaPizzaSlice" },
  { Icon: FaCoffee, name: "Coffee", componentName: "FaCoffee" },
  { Icon: FaBeer, name: "Beer", componentName: "FaBeer" },
  { Icon: FaWineGlass, name: "Wine", componentName: "FaWineGlass" },
  { Icon: FaCocktail, name: "Cocktail", componentName: "FaCocktail" },
  { Icon: FaAppleAlt, name: "Apple", componentName: "FaAppleAlt" },
  { Icon: FaCarrot, name: "Carrot", componentName: "FaCarrot" },
  { Icon: FaIceCream, name: "Ice Cream", componentName: "FaIceCream" },
  { Icon: FaCar, name: "Car", componentName: "FaCar" },
  { Icon: FaBus, name: "Bus", componentName: "FaBus" },
  { Icon: FaTrain, name: "Train", componentName: "FaTrain" },
  { Icon: FaSubway, name: "Subway", componentName: "FaSubway" },
  { Icon: FaBicycle, name: "Bike", componentName: "FaBicycle" },
  { Icon: FaMotorcycle, name: "Motorcycle", componentName: "FaMotorcycle" },
  { Icon: FaShip, name: "Ship", componentName: "FaShip" },
  { Icon: FaPlaneDeparture, name: "Depart", componentName: "FaPlaneDeparture" },
  { Icon: FaTaxi, name: "Taxi", componentName: "FaTaxi" },
  { Icon: FaTruck, name: "Truck", componentName: "FaTruck" },
  { Icon: FaSun, name: "Sun", componentName: "FaSun" },
  { Icon: FaMoon, name: "Moon", componentName: "FaMoon" },
  { Icon: FaCloud, name: "Cloud", componentName: "FaCloud" },
  { Icon: FaCloudRain, name: "Rain", componentName: "FaCloudRain" },
  { Icon: FaSnowflake, name: "Snow", componentName: "FaSnowflake" },
  { Icon: FaWind, name: "Wind", componentName: "FaWind" },
  { Icon: FaBolt, name: "Lightning", componentName: "FaBolt" },
  { Icon: FaStar, name: "Star", componentName: "FaStar" },
  { Icon: FaMeteor, name: "Meteor", componentName: "FaMeteor" },
  { Icon: FaRainbow, name: "Rainbow", componentName: "FaRainbow" },
  { Icon: FaTree, name: "Tree", componentName: "FaTree" },
  { Icon: FaLeaf, name: "Leaf", componentName: "FaLeaf" },
  { Icon: FaSeedling, name: "Seedling", componentName: "FaSeedling" },
  { Icon: FaCannabis, name: "Cannabis", componentName: "FaCannabis" },
  { Icon: FaPagelines, name: "Plant", componentName: "FaPagelines" },
  { Icon: FaPaw, name: "Paw", componentName: "FaPaw" },
  { Icon: FaDog, name: "Dog", componentName: "FaDog" },
  { Icon: FaCat, name: "Cat", componentName: "FaCat" },
  { Icon: FaFish, name: "Fish", componentName: "FaFish" },
  { Icon: FaHorse, name: "Horse", componentName: "FaHorse" },
  { Icon: FaFacebook, name: "Facebook", componentName: "FaFacebook" },
  { Icon: FaTwitter, name: "Twitter", componentName: "FaTwitter" },
  { Icon: FaInstagram, name: "Instagram", componentName: "FaInstagram" },
  { Icon: FaLinkedin, name: "LinkedIn", componentName: "FaLinkedin" },
  { Icon: FaYoutube, name: "YouTube", componentName: "FaYoutube" },
  { Icon: FaPinterest, name: "Pinterest", componentName: "FaPinterest" },
  { Icon: FaSnapchat, name: "Snapchat", componentName: "FaSnapchat" },
  { Icon: FaTiktok, name: "TikTok", componentName: "FaTiktok" },
  { Icon: FaWhatsapp, name: "WhatsApp", componentName: "FaWhatsapp" },
  { Icon: FaTelegram, name: "Telegram", componentName: "FaTelegram" },
  { Icon: FaApple, name: "Apple", componentName: "FaApple" },
  { Icon: FaAndroid, name: "Android", componentName: "FaAndroid" },
  { Icon: FaWindows, name: "Windows", componentName: "FaWindows" },
  { Icon: FaLinux, name: "Linux", componentName: "FaLinux" },
  { Icon: FaChrome, name: "Chrome", componentName: "FaChrome" },
  { Icon: FaFirefox, name: "Firefox", componentName: "FaFirefox" },
  { Icon: FaSafari, name: "Safari", componentName: "FaSafari" },
  { Icon: FaEdge, name: "Edge", componentName: "FaEdge" },
  { Icon: FaOpera, name: "Opera", componentName: "FaOpera" },
  { Icon: FaInternetExplorer, name: "IE", componentName: "FaInternetExplorer" },
  { Icon: FaLock, name: "Lock", componentName: "FaLock" },
  { Icon: FaKey, name: "Key", componentName: "FaKey" },
  { Icon: FaShieldAlt, name: "Shield", componentName: "FaShieldAlt" },
  { Icon: FaUserSecret, name: "Spy", componentName: "FaUserSecret" },
  { Icon: FaFingerprint, name: "Print", componentName: "FaFingerprint" },
  { Icon: FaUnlock, name: "Unlock", componentName: "FaUnlock" },
  { Icon: FaUserLock, name: "User Lock", componentName: "FaUserLock" },
  { Icon: FaFileContract, name: "Contract", componentName: "FaFileContract" },
  { Icon: FaIdCard, name: "ID", componentName: "FaIdCard" },
  { Icon: FaUserShield, name: "Secure", componentName: "FaUserShield" },
  { Icon: FaShoppingCart, name: "Cart", componentName: "FaShoppingCart" },
  { Icon: FaStore, name: "Store", componentName: "FaStore" },
  { Icon: FaShoppingBag, name: "Bag", componentName: "FaShoppingBag" },
  { Icon: FaTags, name: "Tags", componentName: "FaTags" },
  { Icon: FaBarcode, name: "Barcode", componentName: "FaBarcode" },
  { Icon: FaGift, name: "Gift", componentName: "FaGift" },
  { Icon: FaTruckLoading, name: "Delivery", componentName: "FaTruckLoading" },
  { Icon: FaBoxOpen, name: "Open Box", componentName: "FaBoxOpen" },
  { Icon: FaAmazon, name: "Amazon", componentName: "FaAmazon" },
  { Icon: FaEbay, name: "eBay", componentName: "FaEbay" },
  { Icon: FaHome, name: "Home", componentName: "FaHome" },
  { Icon: FaBuilding, name: "Building", componentName: "FaBuilding" },
  { Icon: FaWarehouse, name: "Warehouse", componentName: "FaWarehouse" },
  { Icon: FaIgloo, name: "Igloo", componentName: "FaIgloo" },
  { Icon: FaCampground, name: "Camp", componentName: "FaCampground" },
  { Icon: FaDoorOpen, name: "Door Open", componentName: "FaDoorOpen" },
  { Icon: FaBed, name: "Bed", componentName: "FaBed" },
  { Icon: FaBath, name: "Bath", componentName: "FaBath" },
  { Icon: FaChair, name: "Chair", componentName: "FaChair" },
  { Icon: FaCouch, name: "Couch", componentName: "FaCouch" },
  { Icon: FaCamera, name: "Camera", componentName: "FaCamera" },
  { Icon: FaVideo, name: "Video", componentName: "FaVideo" },
  { Icon: FaFilm, name: "Film", componentName: "FaFilm" },
  { Icon: FaImage, name: "Image", componentName: "FaImage" },
  { Icon: FaPhotoVideo, name: "Media", componentName: "FaPhotoVideo" },
  { Icon: FaTv, name: "TV", componentName: "FaTv" },
  { Icon: FaBroadcastTower, name: "Broadcast", componentName: "FaBroadcastTower" },
  { Icon: FaMicrophoneAlt, name: "Mic Alt", componentName: "FaMicrophoneAlt" },
  { Icon: FaVolumeUp, name: "Volume", componentName: "FaVolumeUp" },
  { Icon: FaSlidersH, name: "Sliders", componentName: "FaSlidersH" },
  { Icon: FaPen, name: "Pen", componentName: "FaPen" },
  { Icon: FaPencilAlt, name: "Pencil", componentName: "FaPencilAlt" },
  { Icon: FaEdit, name: "Edit", componentName: "FaEdit" },
  { Icon: FaEraser, name: "Eraser", componentName: "FaEraser" },
  { Icon: FaPaintBrush, name: "Brush", componentName: "FaPaintBrush" },
  { Icon: FaPalette, name: "Palette", componentName: "FaPalette" },
  { Icon: FaFillDrip, name: "Fill", componentName: "FaFillDrip" },
  { Icon: FaStamp, name: "Stamp", componentName: "FaStamp" },
  { Icon: FaCut, name: "Cut", componentName: "FaCut" },
  { Icon: FaCopy, name: "Copy", componentName: "FaCopy" },
  { Icon: FaPhone, name: "Phone", componentName: "FaPhone" },
  { Icon: FaMobileAlt, name: "Mobile", componentName: "FaMobileAlt" },
  { Icon: FaTabletAlt, name: "Tablet", componentName: "FaTabletAlt" },
  { Icon: FaLaptop, name: "Laptop", componentName: "FaLaptop" },
  { Icon: FaDesktop, name: "Desktop", componentName: "FaDesktop" },
  { Icon: FaKeyboard, name: "Keyboard", componentName: "FaKeyboard" },
  { Icon: FaMouse, name: "Mouse", componentName: "FaMouse" },
  { Icon: FaPrint, name: "Print", componentName: "FaPrint" },
  { Icon: FaFax, name: "Fax", componentName: "FaFax" },
  { Icon: FaSatellite, name: "Satellite", componentName: "FaSatellite" },
  { Icon: FaTools, name: "Tools", componentName: "FaTools" },
  { Icon: FaWrench, name: "Wrench", componentName: "FaWrench" },
  { Icon: FaHammer, name: "Hammer", componentName: "FaHammer" },
  { Icon: FaScrewdriver, name: "Screw", componentName: "FaScrewdriver" },
  { Icon: FaRuler, name: "Ruler", componentName: "FaRuler" },
  { Icon: FaMagnet, name: "Magnet", componentName: "FaMagnet" },
  { Icon: FaBatteryFull, name: "Battery", componentName: "FaBatteryFull" },
  { Icon: FaLightbulb, name: "Lightbulb", componentName: "FaLightbulb" },
  { Icon: FaPlug, name: "Plug", componentName: "FaPlug" },
  { Icon: FaPowerOff, name: "Power", componentName: "FaPowerOff" },
  { Icon: MdEmail, name: "Email", componentName: "MdEmail" },
  { Icon: MdMessage, name: "Message", componentName: "MdMessage" },
  { Icon: MdChat, name: "Chat", componentName: "MdChat" },
  { Icon: MdForum, name: "Forum", componentName: "MdForum" },
  { Icon: MdCall, name: "Call", componentName: "MdCall" },
  { Icon: MdContactMail, name: "Contact Mail", componentName: "MdContactMail" },
  { Icon: MdContactPhone, name: "Contact Ph", componentName: "MdContactPhone" },
  { Icon: MdImportContacts, name: "Import", componentName: "MdImportContacts" },
  { Icon: MdPermContactCalendar, name: "Calendar", componentName: "MdPermContactCalendar" },
  { Icon: MdNotifications, name: "Notify", componentName: "MdNotifications" },
  { Icon: MdDashboard, name: "Dashboard", componentName: "MdDashboard" },
  { Icon: MdSettings, name: "Settings", componentName: "MdSettings" },
  { Icon: MdAccountCircle, name: "Account", componentName: "MdAccountCircle" },
  { Icon: MdLogout, name: "Logout", componentName: "MdLogout" },
  { Icon: MdLogin, name: "Login", componentName: "MdLogin" },
  { Icon: MdHelp, name: "Help", componentName: "MdHelp" },
  { Icon: MdInfo, name: "Info", componentName: "MdInfo" },
  { Icon: MdWarning, name: "Warning", componentName: "MdWarning" },
  { Icon: MdError, name: "Error", componentName: "MdError" },
  { Icon: MdCheckCircle, name: "Success", componentName: "MdCheckCircle" },
  { Icon: FaUser, name: "User", componentName: "FaUser" },
  { Icon: FaUsers, name: "Users", componentName: "FaUsers" },
  { Icon: FaSearch, name: "Search", componentName: "FaSearch" },
  { Icon: FaBars, name: "Menu", componentName: "FaBars" },
  { Icon: FaTimes, name: "Close", componentName: "FaTimes" },
  { Icon: FaCheck, name: "Check", componentName: "FaCheck" },
  { Icon: FaArrowRight, name: "Arrow R", componentName: "FaArrowRight" },
  { Icon: FaArrowLeft, name: "Arrow L", componentName: "FaArrowLeft" },
  { Icon: FaChevronDown, name: "Down", componentName: "FaChevronDown" },
  { Icon: FaChevronUp, name: "Up", componentName: "FaChevronUp" },
];

const IconRenderer = ({ icon, index, onShowCode }) => {
  return (
    <div className="icon-card" onClick={() => onShowCode(icon)}>
      <div className="icon-meta-header">
        <span className="icon-label">
          {index + 1}. {icon.name}
        </span>
        <button
          className="icon-action-btn"
          onClick={(e) => {
            e.stopPropagation();
            onShowCode(icon);
          }}
          title="View Code"
        >
          <LuCopy />
        </button>
      </div>

      <div className="icon-preview-area">
        <div className="icon-main-preview">
          <icon.Icon />
        </div>
      </div>

      <div className="icon-details-footer">
        <div className="icon-desc-text">{icon.name} Icon</div>
      </div>
    </div>
  );
};

const Icons = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  const [viewerState, setViewerState] = useState({
    isOpen: false,
    name: "",
    jsx: "",
    css: "",
  });

  const totalPages = Math.ceil(rawIcons.length / itemsPerPage);
  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;

  const currentItems = useMemo(() => {
    return rawIcons.slice(indexOfFirstItem, indexOfFirstItem + itemsPerPage);
  }, [currentPage, indexOfFirstItem]);

  const handleShowCode = (icon) => {
    const functionName = icon.componentName || "Icon";
    const importLib = functionName.startsWith("Fa")
      ? "react-icons/fa"
      : "react-icons/md";

    const html = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${icon.name} Icon - CodePulse UI</title>
    <!-- Icons are best used with a library like react-icons -->
    <style>
        .icon-container {
            font-size: 3rem;
            color: #ffd700;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
            background: #000;
        }
    </style>
</head>
<body>
    <div class="icon-container">
        <!-- In React: <${functionName} /> -->
        <!-- In HTML: Use an SVG icon or FontAwesome link -->
        <span>${icon.name} Icon</span>
    </div>
</body>
</html>`;

    const css = `/* Icon Styling */\n.icon-style {\n  font-size: 2rem;\n  color: #ffd700;\n  transition: transform 0.3s ease;\n}\n\n.icon-style:hover {\n  transform: scale(1.2);\n}`;
    const jsx = `import { ${functionName} } from "${importLib}";\n\nconst MyComponent = () => {\n  return (\n    <${functionName} className="icon-style" />\n  );\n};`;

    setViewerState({
      isOpen: true,
      name: icon.name,
      jsx: jsx, // Show JSX for icons by default
      css: css,
    });
  };

  return (
    <div className="icons-page-wrapper">
      <div className="library-header">
        <div className="header-content">
          <h1>
            <FaLaptopCode /> Icons <span>Library</span>
          </h1>
        </div>
      </div>

      <div className="icon-grid">
        {currentItems.map((icon, index) => (
          <IconRenderer
            key={`${icon.name}-${index}`}
            icon={icon}
            index={indexOfFirstItem + index}
            onShowCode={handleShowCode}
          />
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        totalItems={rawIcons.length}
        itemsPerPage={itemsPerPage}
      />

      <CodeViewer
        isOpen={viewerState.isOpen}
        onClose={() => setViewerState({ ...viewerState, isOpen: false })}
        componentName={viewerState.name}
        jsxCode={viewerState.jsx}
        cssCode={viewerState.css}
      />
    </div>
  );
};

export default Icons;
